<template>
        <div class="banner">
            <h1>Discover the true self on the inside</h1>
            <h3>Are you curious about kinky sex? Ever wonder what sexual archetype dominates you?<br>
                Take the kinktest to find out your role in BDSM<br>
                TIME TO EMBRACE YOUR SHADOW SIDE!</h3>
            <router-link class="btn_getstart" to="/starttest">Get Started</router-link>
        </div>
</template>
<script>
    export default {
        name:"index"
    }
</script>

<style scoped>

</style>
